import React, { useState } from 'react'
import { useFormik } from 'formik';
import OtpInput from 'react-otp-input';
import Reset from '../../Assets/images/reset.png';
import { changePin, logOutApi } from '../../Context/api';
import axios from 'axios';
import { toast, ToastContainer } from 'react-toastify';
import { commonMessage, statusCodes } from '../../Constants/generalConfig';
import { changePinValidation } from '../../Context/validation';
import Spinner from '../Spinner/spinner';
import { useNavigate } from 'react-router-dom';

const ChangePin = () => {
  const adminData = JSON.parse(localStorage.getItem('adminData'))
  const [spinner, setSpinner] = useState(false)
  const timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
  const navigate = useNavigate()

  const logOutFun = () => {
    axios.post(logOutApi(), { deviceId: adminData.deviceId }, { headers: { Authorization: `Bearer ${adminData.token}` } }).then((resp) => {
      if (resp.data.code === statusCodes.ok) {
        localStorage.removeItem('adminData')
        navigate('/')
      }
    })
  }
  const pinChange = useFormik({
    initialValues: {
      oldPin: '',
      newPin: '',
      confirmNewPin: '',
    },
    validationSchema: changePinValidation,
    onSubmit: values => {
      const data = {
        mobileNo: adminData.mobileNo,
        email: adminData.email,
        oldPassword: values.oldPin,
        newPassword: values.newPin,
        timeZone: timeZone
      }
      setSpinner(true)
      axios.post(changePin(), { ...data }).then((resp) => {
        if (resp.data.code === statusCodes.ok) {
          toast.success(resp.data.message)
          pinChange.resetForm();
          setSpinner(false)
        }
        else if (resp.data.code === statusCodes.tokenExpire) {
          logOutFun()
        }
        else {
          toast.error(resp.data.message)
          setSpinner(false)
        }
      })
        .catch(() => {
          toast.error(commonMessage.networkError)

        })
    },
  });
  return (
    <>
      <ToastContainer />
      <section>
        <div className="m-t-3 cus-padd cusheight" style={{ borderRadius: "15px" }}>
          {spinner ? <Spinner /> : null}
          <header>
            <h2 className='page-tittle'>Change Pin</h2>
            <hr />
          </header>
          <div className="row">
            <div className="text-center">
              <img src={Reset} alt='' />
              <h1 className="text-center  mb-3">Change Pin</h1>
              <form className="cus-form" onSubmit={pinChange.handleSubmit}>
                <label className="form-label">Enter Old Pin *</label>
                <div className="pin-code mb-3">
                  <OtpInput isInputNum numInputs={4} isInputSecure
                    name='oldPin'
                    onChange={(e) => { pinChange.setFieldValue("oldPin", e) }}
                    value={pinChange.values.oldPin} />
                </div>
                {pinChange.touched.oldPin && pinChange.errors.oldPin ? (
                  <div style={{ color: 'red', fontSize: '12px' }}>{pinChange.errors.oldPin}</div>
                ) : null}
                <label className="form-label">Enter New Pin *</label>
                <div className="pin-code">
                  <OtpInput
                    isInputNum
                    isInputSecure
                    numInputs={4}
                    name='newPin'
                    onChange={(e) => { pinChange.setFieldValue("newPin", e) }}
                    value={pinChange.values.newPin} />
                </div>
                {pinChange.touched.newPin && pinChange.errors.newPin ? (
                  <div style={{ color: 'red', fontSize: '12px' }}>{pinChange.errors.newPin}</div>
                ) : null}
                <label className="form-label mt-2">Confirm New Pin *</label>
                <div className="pin-code">
                  <OtpInput
                    isInputNum
                    isInputSecure
                    numInputs={4}
                    name='confirmNewPin'
                    onChange={(e) => { pinChange.setFieldValue("confirmNewPin", e) }}
                    value={pinChange.values.confirmNewPin} />
                </div>
                {pinChange.touched.confirmNewPin && pinChange.errors.confirmNewPin ? (
                  <div style={{ color: 'red', fontSize: '12px' }}>{pinChange.errors.confirmNewPin}</div>
                ) : null}
                <div className="d-grid  col-6  mt-5 justify-content-end" style={{ marginLeft: '100px' }}>
                  <button type='submit' className="btn profile-btn sidebtn">Update</button>
                </div>
              </form>
            </div>
          </div>
        </div>
      </section>
    </>
  )
}

export default ChangePin;